export * from './plate-number-format-strategy';
export * from './plate-number-strategy';
